<template>
  <div>
    <div style="display: flex; width: 100%; justify-content: space-between; border-bottom: 1px solid lightgray; margin-bottom: 20px;">
      <p style="font-size: 32px; font-weight: bold;">
        {{ $t("CalculationEmployees") }}
      </p>
      <div
        style="display: flex; justify-content: center;
        align-items: center;"
      >
        <div
          style="display: flex;
          align-items: center; margin-right: 5px;"
          :disabled="getEmployeeHours.length == 0"
        >
          <button
            :disabled="getEmployeeHours.length == 0"
            style="    border: 0;
            width: 48px;
            height: 37px; background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box; border-radius: 5px;"
            @click="downloadPDF"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="white"
              class="bi bi-file-earmark-pdf"
              viewBox="0 0 16 16"
            >
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
              <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
            </svg>
          </button>
        </div>
        <div
          :disabled="getEmployeeHours.length == 0"
        >
          <button
            style="    border: 0;
            width: 48px;
            height: 37px; background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box; border-radius: 5px;"
            :disabled="getEmployeeHours.length == 0"
            @click="downloadEXCEL"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="white"
              class="bi bi-file-earmark-spreadsheet"
              viewBox="0 0 16 16"
            >
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <div style="display: flex; flex-direction: row">
        <b-form-group
          id="input-group-9"
          :label="$t('Store')"
          label-for="input-9"
          style="margin-bottom: 10px; width: 200px;"
        >
          <vue-select
            ref="storeSelect"
            v-model="store"
            :disabled="!selection"
            :clearable="false"
            required
            :options="getFiliales"
            label="storeName"
            :value="storeId"
            :placeholder="$t('Select')"
            aria-describedby="input-1-live-feedback"
            @search="onSearchM"
            @clear="clearSelection"
          />
        </b-form-group>
        <div style="display: flex; align-items: center; margin: 0 15px;margin-top: 15px">
          <b-form-radio
            v-model="selection"
            :value="true"
          >
            <span style="margin: 5px">

              {{ $t("Internal") }}
            </span>

          </b-form-radio>
          <b-form-radio
            v-model="selection"
            :value="false"
            style="margin-left: 10px"
          >
            <span
              style="margin: 5px"
            >

              {{ $t("External") }}
            </span>

          </b-form-radio>
        </div>
        <b-form-group
          id="input-group-9"
          :label="$t('CalculationEmployee')"
          label-for="input-9"
          style="margin-bottom: 10px; width: 200px;  margin-left: 15px"
        >
          <vue-select
            ref="storeSelect"
            v-model="employee"
            :clearable="false"
            required
            :options="getRegularEmployeesOverview"
            label="userFullName"
            :placeholder="$t('Select')"
            aria-describedby="input-1-live-feedback"
            @search="onSearchM"
            @clear="clearSelection"
          />
          <!-- :value="userId" -->
        </b-form-group>
        <b-form-group
          id="input-group-9"
          :label="$t('CalculationStartingDate')"
          label-for="input-9"
        >
          <date-picker
            v-model="time1"
            type="datetime"
            style="height: 40px"
            value-type="format"
            :placeholder="$t('Select')"
            :format="'DD-MM-YYYY' + ' ' + 'HH:mm'"
            :lang="lang"
          />
        </b-form-group>
        <b-form-group
          id="input-group-9"
          :label="$t('CalculationEnding Date')"
          label-for="input-9"
        >
          <date-picker
            v-model="time2"
            type="datetime"
            value-type="format"
            style="height: 50px"
            :placeholder="$t('Select')"
            :format="'DD-MM-YYYY' + ' ' + 'HH:mm'"
            :lang="lang"
          />
        </b-form-group>
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          :disabled="this.store == null || this.employee == null || this.time1== null || this.time2== null"
          @click="calculateFilialeHours"
        >
          {{ $t("CalculationCalculate") }}
        </b-button>
      </div>

    </div>
    <div style="width: 100%; padding-top: 16px; margin-top: -3px; height: 750px; overflow-y: scroll;">
      <table
        class="team_table"
        style="width: 100% !important; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%)"
      >
        <thead>
          <tr>
            <th style="padding: 10px; text-align: left;">
              {{ $t("CalculationDate") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("CalculationStoreGLN") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("CalculationWorkedH") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- getTrucksPagination getTrucksByStore -->
          <tr
            v-for="name in getEmployeeHours"
            :key="name.id"
            style="border-bottom: 1px solid #dcdfe6; color: #606266; cursor: pointer"
            @click="matProps(filiale)"
          >
            <td style="padding: 10px; text-align: left;">
              {{ dateModified2(name.dateWorked) }}
            </td>
            <td style="padding: 10px; text-align: left;">
              {{ name.storeGLN }}
            </td>
            <td style="padding: 10px; text-align: left;">
              {{ dateFormat(name.workedHours) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <AddExchangeTruckModal
      @click="assignExchangeTruck"
      @clickk="assignExchangeTruckToPrivateUser"
    />
    <EditTruckModal
      :edit-truck="truck"
      @edit="editTruck"
    />
    <DeactivateTruckModal
      :item="Id"
      @click="deactivateTruck"
    />
    <EditStoreToTrucks
      :item="truckId"
      @assignFiliale="handleAssignStore"
    />
    <CancelExchangeTruck
      :item="Id"
      :item2="exchangeId"
      @click="cancelExchangeTruck"
    />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// eslint-disable-next-line no-unused-vars
import AddExchangeTruckModal from '@/components/trucks/modals/AddExchangeTruckModal.vue';
import EditTruckModal from '@/components/trucks/modals/EditTruckModal.vue';
import CancelExchangeTruck from '@/components/trucks/modals/CancelExchangeTruck.vue';
import DeactivateTruckModal from '@/components/trucks/modals/DeactivateTruck.vue'
import EditStoreToTrucks from '@/components/trucks/modals/EditStoreToTrucks.vue'
// import EditDressColorModal from '@/components/products/modals/EditDressColorModal.vue';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import axios from 'axios'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';



export default {
  components: {
    AddExchangeTruckModal,
    EditTruckModal,
    DeactivateTruckModal,
    EditStoreToTrucks,
    DatePicker,
    CancelExchangeTruck,
    // EditDressColorModal,
  },
  // eslint-disable-next-line vue/require-prop-types
  data() {
    return {
      initialId: '',
      store: null,
      employee: null,
      destination: 'ALL',
      selection: true,
      status: true,
      statuss: false,
      storeId: null,
      employeeId: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      storeIdd: null,
      classNameCh: '',
      time1: null,
      time2: null,
      searchTerm: '',
      rows: [],
      materialObject: {},
      pageM: 1,
      editMat: {},
      selectedDate: moment().format('DD-MM-YYYY'),
      page: 1,
      isactive: true,
      pageSize: 15,
      pageNumber: 1,
      test: null,
      pressed: false,
      noSearch: false,
      searchPlate: '',
      arrowCounter: 0,
      truckId: '',
      exchangeId: '',
      Id: '',
      enterPressed: false,
      truck: {
        truckId: '',
        brandName: '',
        modelName: '',
        variantName: '',
        registrationPlate: '',
        firstRegistration: '',
        insuranceExpirationDate: '',
        storeName: '',
      },
      color: {
        mainDressCategoryColorId: '',
        name: '',
      },
      getFiliale: {
        filialeName: 'Mercedes',
        address: 'Sprinter',
        todayRoutes: 'LU-2142131',
        trucks: '12/03/2018',
        totalEmployee: '12/03/2023',
      },
    };
  },

  computed: {
    ...mapGetters([
      'getDressColors',
      'getFiliales',
      'getTotalItemsForFiliales',
      'getTotalItemsForFiliales',
      'getCurrentPageForStore',
      'getTrucksPagination',
      'getTrucksByStore',
      'getFilialesForTrucks',
      'getFilterPlateTruck',
      'getTotalItemsForTrucks',
      'getRoutersForTrucks',
      'getExchangeTrucks',
      'getFilialesForRoutes',
      'getFilterPlateExchangeTruck',
      'getTotalItemsForEXTrucks',
      'getEmployeeHours',
      'getRegularEmployeesOverview',
      'getLoggedInUser',
    ]),
    isValidDate() {
      if (!this.time1 || !this.time2) {
        return true; // allow empty dates
      }
      const start = moment(this.time1, 'DD-MM-YYYY HH:mm').toDate();
      const end = moment(this.time2, 'DD-MM-YYYY HH:mm').toDate();
      return start <= end;
    },
  },
  watch: {
    pageNumber(value) {
      this.loadExchangeTrucksByPagination({
        registrationPlate: null,
        sourceStoreId: null,
        destinationStoreId: null,
        startShift: null,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    selection(value) {
      if (value == true) {
        this.loadRegularEmployeeOverview({
          storeId: this.storeIdd,
          status: true,
          isRegular: true,
        })
      } else {
        this.loadRegularEmployeeOverview({
          storeId: '00000000-0000-0000-0000-000000000000',
          status: true,
          isRegular: false,
        })
      }
    },
    store(value) {
      this.storeIdd = value.storeId
      this.loadRegularEmployeeOverview({
        storeId: value.storeId,
        status: true,
        isRegular: true,
      })
      this.employee = null
    },
    employee(value) {
      // console.log(value)
      this.employeeId = value.userId
    },
    time1(value) {
      // const res = moment.tz.guess();
      // const value2 = moment.utc(value, 'DD-MM-yyyyTHH:mm:ss');
      // const formattedDate = moment.tz(value2, 'DD-MM-yyyyTHH:mm:ss', res).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      // this.startDate = formattedDate
      const res = moment.tz.guess();
      const value2 = moment(value, 'DD-MM-yyyyTHH:mm:ss');
      this.startDate = moment.tz(value2, 'DD-MM-yyyyTHH:mm:ss', res).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // Note the [Z] added to format
      this.startDate = this.startDate.replace(/\+/, '%2B');
    },
    time2(value) {
      // const res = moment.tz.guess();
      // const value2 = moment.utc(value, 'DD-MM-yyyyTHH:mm:ss');
      // const formattedDate = moment.tz(value2, 'DD-MM-yyyyTHH:mm:ss', res).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      // this.endDate = formattedDate

      const res = moment.tz.guess();
      const value2 = moment(value, 'DD-MM-yyyyTHH:mm:ss');
      this.endDate = moment.tz(value2, 'DD-MM-yyyyTHH:mm:ss', res).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // Note the [Z] added to format
      this.endDate = this.endDate.replace(/\+/, '%2B');
    },
    isValidDate(newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.time2 = null;
      }
    },

  },
  mounted() {
    // this.fetchExchangeTrucks();
    this.fetchFiliale();
    // this.fetchFilialeForExchangeTrucks();
  },
  methods: {
    ...mapActions([
      'addColorToMainDressCategoryById',
      'editColorToMainDressCategoryById',
      'loadDressColorsById',
      'inventoryProductSizeFromColorId',
      'resetProductsByArticleNumber',
      'resetCustomOrders',
      'loadFilialePagination',
      'changeLoadingtoTrue',
      'loadFilteredStoreName',
      'addTruck',
      'loadTrucksPaginationWithoutStore',
      'loadTrucksByStore',
      'loadFilialePaginationForTrucks',
      'loadFilteredPlateTruck',
      'resetFilteredPlate',
      'editTruckById',
      'loadToursForTrucks',
      'deactivateAndActivateTruck',
      'assignTruckStore',
      'assignExchangeFreeRegularTrucks',
      'loadExchangeTrucksByPagination',
      'assignExchangeTruckStore',
      'assignExchangeTruckStoreToPrivateuser',
      'cancelEXTruck',
      'loadFilialePaginationForRoutes',
      'loadFilteredPlateExchangeTruck',
      'resetFilteredPlateExchangeTruck',
      'loadEmployeeHours',
      'loadRegularEmployeeOverview',
    ]),


    downloadPDF() {
      // axios
      //   .get(`https://logistictourmanagement.digitwebsite.ch/api/v1/workingHoursForEmployee?employeeUserId=${this.employeeId}&startDate=${this.startDate}&endDate=${this.endDate}`)
      this.loadEmployeeHours({
        employeeUserId: this.employeeId,
        startDate: this.startDate,
        endDate: this.endDate,
      }).then(() => {
        // const data = this.getEmployeeHours;
        // const items = data.items;

        const tableContent = this.generateTableContent(this.getEmployeeHours);

        const totalPages = this.getEmployeeHours.totalPages;
        const additionalPromises = [];
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          additionalPromises.push(this.downloadPage(pageNumber));
        }

        Promise.all(additionalPromises).then((additionalTableContents) => {
          additionalTableContents.forEach((additionalTableContent) => {
            tableContent.body.push(...additionalTableContent.body);
          });
          const spimLogo = 'data:image/png;base64,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'
          const clientLogo = 'data:image/png;base64,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'
          const digITLogo = 'data:image/png;base64,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'

          const pdfDocument = this.generatePDF(tableContent, clientLogo, spimLogo, digITLogo);
          pdfDocument.save(`${this.employee.userFullName}_${moment().format('DD/MM/YYYY - hh-mm-s')}.pdf`);
        });
      })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    downloadPage() {
      return this.loadEmployeeHours({
        employeeUserId: this.employeeId,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then(() => {
          // const data = response.data;
          // const items = data;

          return this.generateTableContent(this.getEmployeeHours);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generateTableContent(items) {
      const headers = [`${this.$t('CalculationDate')}`, `${this.$t('CalculationStoreGLN')}`, `${this.$t('CalculationWorkedH')}`];

      const body = items.map((item) => {
        return [
          this.dateModified2(item.dateWorked),
          item.storeGLN,
          item.workedHours,
        ]
      });

      return { headers, body };
    },
    generatePDF(tableContent, clientLogo, spimLogo, digITLogo) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF();
      // Add the logo to the top left corner of the first page
      const iconWidthClient = 35; // Adjust the width of the icon as needed
      const iconHeightClient = 10; // Adjust the height of the icon as needed
      const iconYClient = 10; // Adjust the vertical position of the icon (top)
      const iconXClient = 15; // Adjust the horizontal position of the icon (left)

      const iconWidthSpim = 32; // Adjust the width of the icon as needed
      const iconHeightSpim = 12; // Adjust the height of the icon as needed
      const iconYSpim = 10; // Adjust the vertical position of the icon (top)
      const iconXSpim = 165; // Adjust the horizontal position of the icon (left)

      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 30; // Adjust the height as needed
      doc.setFillColor(0, 113, 174); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      // Add the logo image on top of the blue background on the top left
      doc.addImage(clientLogo, 'SVG', iconXClient, iconYClient, iconWidthClient, iconHeightClient);

      // const iconX = 15; // Adjust the horizontal position of the icon (left)
      doc.addImage(spimLogo, 'SVG', iconXSpim, iconYSpim, iconWidthSpim, iconHeightSpim);

      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 15;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 35;
        doc.setFillColor(0, 113, 174); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        const url = 'www.dslogistik.ch';
        const urlX = doc.internal.pageSize.getWidth() / 13;
        const urlY = doc.internal.pageSize.getHeight() - 9;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'left' });

        // Add address
        const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
        const addressX = doc.internal.pageSize.getWidth() / 13;
        const addressY = doc.internal.pageSize.getHeight() - 4;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'left' });

        // Add address
        const digIT = 'Powered By';
        const digITX = doc.internal.pageSize.getWidth() - 40;
        const digITY = doc.internal.pageSize.getHeight() - 6;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(digIT, digITX, digITY, { align: 'right' });


        const iconWidthDigIT = 25; // Adjust the width of the icon as needed
        const iconHeightDigIT = 15; // Adjust the height of the icon as needed
        const iconXDigIT = doc.internal.pageSize.getWidth() - 40; // Adjust the horizontal position of the icon (left)
        const iconYDigIT = doc.internal.pageSize.getHeight() - 15; // Adjust the vertical position of the icon (top)

        doc.addImage(digITLogo, 'SVG', iconXDigIT, iconYDigIT, iconWidthDigIT, iconHeightDigIT);
      };
      // const currentTime = `${this.$t('PrintingDate')}: ${moment().format('DD/MM/YYYY, HH:mm:ss')}`;

      // const timeX = doc.internal.pageSize.getWidth() / (10 / 9);
      // const timeY = 10;
      // doc.setFontSize(10);
      // doc.setTextColor(255, 255, 255); // Black color
      // doc.text(currentTime, timeX, timeY, { align: 'right' });


      // Add the title
      const title = this.$t('CalculationEmployees').toUpperCase();
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 18; // Adjust the vertical position of the title
      doc.setFontSize(15);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // Add the Employeer
      const authorX = 15;
      const authorY = 40; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`.toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author').toUpperCase()}: ${author}`, authorX, authorY);
      // Add the employee
      const employeeX = 15;
      const employeeY = 47; // Adjust the vertical position of the employee
      const employee = this.employee.userFullName.toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('EmployeeName').toUpperCase()}: ${employee}`, employeeX, employeeY);

      const yearX = 15;
      const yearY = 54; // Adjust the vertical position of the year
      const year = `${this.year}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Year').toUpperCase()}: ${year}`, yearX, yearY);

      const printingX = doc.internal.pageSize.getWidth() - 45;
      const printingY = 37; // Adjust the vertical position of the printing
      const printing = this.$t('PrintingDate').toUpperCase();
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${printing}`, printingX, printingY);

      const dateX = doc.internal.pageSize.getWidth() - 45;
      const dateY = 42; // Adjust the vertical position of the date
      const date = `${moment().format('MMM D, YYYY')}`;
      doc.setFontSize(13);
      doc.setTextColor(85, 185, 74)// Black color
      doc.text(`${date.toUpperCase()}`, dateX, dateY);

      const timeX = doc.internal.pageSize.getWidth() - 45;
      const timeY = 47; // Adjust the vertical position of the time
      const time = `${this.$t('Time').toUpperCase()}: ${moment().format('HH:mm:ss')}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${time}`, timeX, timeY);

      // Add the table
      const tableOptions = {
        startY: authorY + 10, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [0, 113, 174], // Set the background color for the header
          textColor: [255, 255, 255], // Set the text color for the header
        },
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);

      // const iconWidthh = 30; // Adjust the width of the icon as needed
      // const iconHeightt = 10; // Adjust the height of the icon as needed
      // // const iconX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // // const iconY = doc.internal.pageSize.getHeight() - 35; // Adjust the vertical position of the icon
      // const iconXX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // const iconYY = doc.internal.pageSize.getHeight() - 18; // Adjust the vertical position of the icon

      // doc.addImage(footerIcon, 'PNG', iconXX, iconYY, iconWidthh, iconHeightt);

      // const hrLineY = doc.internal.pageSize.getHeight() - 20;
      // const hrLineX1 = 50;
      // const hrLineX2 = doc.internal.pageSize.getWidth() - 50;
      // doc.setLineWidth(0.5); // Adjust the line thickness as needed
      // doc.line(hrLineX1, hrLineY, hrLineX2, hrLineY);

      // const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland, 032 671 20 10';
      // const addressX = doc.internal.pageSize.getWidth() / 2;
      // const addressY = doc.internal.pageSize.getHeight() - 2;
      // doc.setFontSize(8);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(address, addressX, addressY, { align: 'center' });

      return doc;
    },



    generateTableContent2(items) {
      const headers = [`${this.$t('CalculationDate')}`, `${this.$t('CalculationStoreGLN')}`, `${this.$t('CalculationWorkedH')}`];

      const body = items.map((item) => {
        return [
          this.dateModified2(item.dateWorked),
          item.storeGLN,
          item.workedHours,
        ]
      });

      return { headers, body };
    },
    generateExcel(tableContent) {
      const { headers, body } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      return excelData;
    },
    downloadEXCEL() {
      // axios
      //   .get(`https://logistictourmanagement.digitwebsite.ch/api/v1/workingHoursForEmployee?employeeUserId=${this.employeeId}&startDate=${this.startDate}&endDate=${this.endDate}`)
      this.loadEmployeeHours({
        employeeUserId: this.employeeId,
        startDate: this.startDate,
        endDate: this.endDate,
      }).then(() => {
        // const data = response.data;
        // const items = data.items;

        const tableContent = this.generateTableContent(this.getEmployeeHours);

        const totalPages = this.getEmployeeHours.totalPages;
        const additionalPromises = [];
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          additionalPromises.push(this.downloadPage(pageNumber));
        }

        Promise.all(additionalPromises).then((additionalTableContents) => {
          additionalTableContents.forEach((additionalTableContent) => {
            tableContent.body = tableContent.body.concat(additionalTableContent.body);
          });

          const excelData = this.generateExcel(tableContent);
          FileSaver.saveAs(excelData, 'EmployeeCalculations.xlsx');
        });
      })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },





    async calculateFilialeHours() {
      // this.changeLoadingtoTrue(false);


      try {
        await this.loadEmployeeHours({
          employeeUserId: this.employeeId,
          startDate: this.startDate,
          endDate: this.endDate,
        }).then(() => {
          // this.changeLoadingtoTrue(true);
        });
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false);
      }
    },
    // async loadFreeEmployees() {
    //   try {
    //     await this.loadRegularEmployeeOverview({
    //       storeId: this.storeIdd,
    //       status: true,
    //     }).then((res) => {
    //       console.log(res);
    //     });
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async fetchExchangeTrucks() {
      try {
        await this.loadExchangeTrucksByPagination({
          registrationPlate: null,
          sourceStoreId: null,
          destinationStoreId: null,
          startShift: null,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        }).then(() => {
        });
      } catch (e) {
        console.log(e);
      }
    },
    assignExchangeTruck(object) {
      this.assignExchangeTruckStore({
        object,
        successCallback: () => {
          this.loadExchangeTrucksByPagination({
            registrationPlate: null,
            sourceStoreId: null,
            destinationStoreId: null,
            startShift: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },
    assignExchangeTruckToPrivateUser(object) {
      this.assignExchangeTruckStoreToPrivateuser({
        object,
        successCallback: () => {
          this.loadExchangeTrucksByPagination({
            registrationPlate: null,
            sourceStoreId: null,
            destinationStoreId: null,
            startShift: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },
    getRoutesPerTrucks() {
      this.loadToursForTrucks({
        truckId: this.Id,
        startShift: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
      })
    },
    async cancelExchangeTruck(value) {
      // console.log('123', value)
      await this.cancelEXTruck({
        exchangeTruckId: value,
        successCallback: () => {
          this.loadExchangeTrucksByPagination({
            registrationPlate: null,
            sourceStoreId: null,
            destinationStoreId: null,
            startShift: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },

    getIDTruck(value) {
      this.Id = value
    },
    getExchangeId(value) {
      this.exchangeId = value
    },
    async loadFreeAssignedFiliales() {
      await this.loadFilialePagination({
        status: this.status,
        pageSize: 2,
        pageNumber: this.pageNumber,
      })
    },
    async fetchFiliale() {
      try {
        //       // this.changeLoadingtoTrue(false);


        await this.loadFilialePagination({
          status: this.status,
          pageSize: 100,
          pageNumber: 1,
        }).then(() => {
          // this.changeLoadingtoTrue(true);
        });
      } catch (e) {
        console.log(e);
        //       // this.changeLoadingtoTrue(false);
      }
    },
    async handleAssignStore(obj) {
      await this.assignTruckStore({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          });
          // this.freeTeamLeaders();
        },
      });
    },
    async filiale() {
      try {
        await this.loadUsersFullNamesById('TeamLeader').then(() => {
          // console.log('eeeee', res);
        });
      } catch (e) {
        console.log(e);
      }
    },
    async fetchFilialeForExchangeTrucks() {
      try {
        //       // this.changeLoadingtoTrue(false);


        await this.loadFilialePaginationForRoutes({
          status: true,
          pageSize: 100,
          pageNumber: this.pageNumber,
        })
      } catch (e) {
        // console.log(e);
        //       // this.changeLoadingtoTrue(false);

      }
    },
    async deactivateTruck(value) {
      // console.log('1235', value)
      try {
        await this.deactivateAndActivateTruck({
          truckId: value.truckId,
          status: value.status,
          successCallback: () => {
            this.loadTrucksPaginationWithoutStore({
              status: this.status,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            });
          // this.freeTeamLeaders();
          },
        }).then(() => {
        });
      } catch (e) {
        console.log(e);
      }
    },
    async activateTruck(value) {
      // console.log('ert', value)
      // console.log(value)
      try {
        await this.deactivateAndActivateTruck({
          truckId: value.truckId,
          status: true,
          successCallback: () => {
            this.loadTrucksPaginationWithoutStore({
              status: this.status,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            });
          // this.freeTeamLeaders();
          },
        }).then(() => {
        });
      } catch (e) {
        console.log(e);
      }
    },



    async addTruckk(obj) {
      await this.addTruck({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          }).then((res) => {
            console.log(res);
          });
        },
      });
    },
    async handleAssignFoliale(obj) {
      await this.assignTeamLeader({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
          // this.freeTeamLeaders();
        },
      });
    },

    async editTruck(obj) {
      // console.log('rreew', obj);
      await this.editTruckById({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            storeId: null,
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          });
        },
      });
    },
    async activeF() {
      this.isactive = !this.isactive;
      this.searchUser = '';
      if (!this.isactive) {
        await this.loadTrucksPaginationWithoutStore({
          status: this.statuss,

          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } else {
        await this.loadTrucksPaginationWithoutStore({
          status: this.status,

          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      }
    },
    dateFormat(value) {
      const duration = moment.duration(value);
      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();

      if (days > 1 && hours > 1) {
        return `${days} days, ${hours} hours, and ${minutes} minutes`;
      } if (days == 1 && hours > 1) {
        return `${days} day, ${hours} hours, and ${minutes} minutes`;
      } if (days == 0 && hours > 1) {
        return `${hours} hours and ${minutes} minutes`;
      }
      return `${hours} hour and ${minutes} minutes`;
      // Use moment to parse the input duration string and create a duration object
      // const duration = moment.duration(value);

      // // Get the hours and minutes from the duration
      // const hours = duration.hours();
      // const minutes = duration.minutes();

      // // Format hours and minutes into HH:mm format
      // const formattedHoursWorked = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

      // return formattedHoursWorked;
    },
    // statusFalse() {
    //   // eslint-disable-next-line no-unused-expressions
    //   this.statuss = false;
    // },
    openEdit(value) {
      this.truck.truckId = value.truckId;
      this.truck.brandName = value.brandName;
      this.truck.modelName = value.modelName;
      this.truck.variantName = value.variantName;
      this.truck.registrationPlate = value.registrationPlate;
      this.truck.firstRegistration = value.firstRegistration;
      this.truck.insuranceExpirationDate = value.insuranceExpirationDate;
      this.truck.storeName = value.storeName;
    },
    edit(item) {
      this.color.mainDressCategoryColorId = item.mainDressCategoryColorId;
      this.color.name = item.colorName;
      this.$bvModal.show('modal-edit-color');
    },
    toggleBtn(truee) {
      this.sync = truee;
    },
    matProps(color) {
      this.resetProductsByArticleNumber();
      this.$emit('click', color);
      this.classNameCh = color.colorName;
      this.inventoryProductSizeFromColorId(color.mainDressCategoryColorId);
    },
    async getMVbyMeter(page, pageS) {
      // const { data } =
      await this.loadFilialePagination({
        status: this.status,
        pageNumber: page,
        pageSize: pageS,
      });
    },
    nextMeter() {
      if (this.pageM < this.getTotalItemsForFiliales) {
        this.pageM += 1;
        this.getMVbyMeter(this.pageM, this.pageSize);
      }
    },
    prevMeter() {
      if (this.pageM > 1) {
        this.pageM -= 1;
        this.getMVbyMeter(this.pageM, this.pageSize);
      }
    },
    async onSearchM(query) {
      await this.loadFilteredStoreName({
        name: query,
      });
      if (query == '') {
        this.testResetMV();
        this.getMVbyMeter(this.getCurrentPageForStore, this.pageSize);
      }
    },
    onArrowDown(ev) {
      ev.preventDefault();
      if (this.arrowCounter < this.getFilterPlateExchangeTruck.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },

    onArrowUp(ev) {
      ev.preventDefault();
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling();
      }
    },

    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true;
        this.searchByOn(this.getFilterPlateExchangeTruck[this.arrowCounter].registrationPlate);
        this.removeLists();
        this.arrowCounter = 0;
        setTimeout(() => {
          this.enterPressed = false;
        }, 1000);
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    matPropss(color) {
      this.truckId = color;
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      // console.log(liH);
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    async searchByOn(value) {
      // console.log('vall', value)
      this.searchPlate = value;
      this.noSearch = false;
      await this.loadExchangeTrucksByPagination({
        registrationPlate: value,
        sourceStoreId: null,
        destinationStoreId: null,
        startShift: this.selectedDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    removeLists() {
      this.noSearch = false;
      this.resetFilteredPlateExchangeTruck();
    },
    async clearSelection() {
      try {
        //       // this.changeLoadingtoTrue(false);


        await this.loadTrucksPaginationWithoutStore({
          storeId: null,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        }).then(() => {
          // this.changeLoadingtoTrue(true);
        });
      } catch (e) {
        console.log(e);
        //       // this.changeLoadingtoTrue(false);
      }
      // this.store = null;
    },
    resetValue() {
      this.$refs.storeSelect.reset();
    },
    dateModified(xdate) {
      // return moment(xdate).format('DD/MM/YYYY - HH:mm');
      return moment(xdate).format('DD/MM/YYYY');
    },
    // dateModified2(xdate) {
    //   return moment.utc(xdate).format('DD/MM/YYYY - HH-mm');
    // },
    dateModified2(xdate) {
      return moment.utc(xdate).format('DD/MM/YYYY - HH-mm');
    },
    previousDay() {
      this.selectedDate = moment(this.selectedDate, 'DD-MM-YYYY').subtract(1, 'days').format('DD-MM-YYYY');
    },
    nextDay() {
      this.selectedDate = moment(this.selectedDate, 'DD-MM-YYYY').add(0.5, 'days').format('DD-MM-YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
// just stuff to make the pen not look terrible


h1 {
  margin: 2em 0 0;
  font-size: 2em;
  font-family: helvetica, ariel, sans-serif;
  text-align: left;
}

h2 {
  margin: 1em 0 2em;
  font-size: 1.4em;
  font-family: helvetica, ariel, sans-serif;
  text-align: left;
}

.codepen-wrapper {
  width: 25%;
  margin: 0 37.5%;
}

// this is the stuff you want.

.registration-ui {
  background: linear-gradient(to bottom, #f8d038 0%, #f5ca2e 100%);
  padding: 0.25em 1em 0.25em 1.75em;
  font-weight: bold;
  font-size: 2em;
  border-radius: 5px;
  border: 1px solid #000;
  box-shadow: 1px 1px 1px #ddd;
  position: relative;
  font-family: helvetica, ariel, sans-serif;
}

.registration-ui:before {
  content: "GB";
  display: block;
  width: 30px;
  height: 100%;
  background: #063298;
  position: absolute;
  top: 0;
  border-radius: 5px 0 0 5px;
  color: #f8d038;
  font-size: 0.5em;
  line-height: 85px;
  padding-left: 5px;
}
span{
  color: black;
}
p{
  color: black;
}
table td{
  color: black;
}
.registration-ui:after {
  content: "";
  display: block;
  position: absolute;
  top: 7px;
  left: 5px;
  width: 20px;
  height: 20px;
  border-radius: 30px;
  border: 1px dashed #f8d038;
}
.search-toggle {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#input-group-9{
  margin-left: 15px;
}
.color-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
  input {
    width: 100px;
  }
}
.button {
  margin-bottom: 15px !important;
  width: 195px;
}
.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}

.buttonSubmit{
  margin-left: 15px;
  height: 40px;
  margin-top: 22px;
  width: 170px
}

@media screen and (max-width: 1823px) {
  .color-listing__wrapper2 {
    width: 200px;
    button {
      width: 90%;
    }
    .team_table {
      width: 150px !important;
    }
  }
}
@media screen and (max-width: 1500px) {
  .color-listing__wrapper {
    margin-left: 50px;
    width: 150px !important;
    .team_table {
      width: 150px !important;
    }
  }
  .color-listing__wrapper2 {
    margin-left: 10px;
    width: 200px !important;
    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
    .team_table {
      width: 100% !important;
    }
  }
  #input-group-9{
    width: 200px;
  }
}

@media screen and (max-width: 1200px){
  .buttonSubmit{
    width: 160px
  }

  #input-group-9{
    width: 120px;
  }

  .team_table {
    width: 150px !important;
  }

}
@media screen and (max-width: 896px) {
  .color-listing__wrapper {
    margin-left: 0 !important;
    flex-basis: 49%;
  }
}
.color-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
  input {
    width: 100px;
  }
}
.button {
  margin-bottom: 15px !important;
  width: 195px;
}
.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}
@media screen and (max-width: 1823px) {
  .color-listing__wrapper2 {
    width: 200px;
    button {
      width: 90%;
    }
    .team_table {
      width: 150px !important;
    }
  }
}
@media screen and (max-width: 1400px) {
  .color-listing__wrapper {
    margin-left: 50px;
    width: 150px !important;
    .team_table {
      width: 150px !important;
    }
  }
  .color-listing__wrapper2 {
    margin-left: 10px;
    width: 200px !important;
    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
    .team_table {
      width: 100% !important;
    }
  }
}
.search1 {
  padding: 0px;
}
.black {
  position: relative;
}
.black input {
  border: none;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
  height: 36px;
}
.dropdrop::-webkit-scrollbar {
  display: none;
}
.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 600;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
@media screen and (max-width: 896px) {
  .color-listing__wrapper {
    margin-left: 0 !important;
    flex-basis: 49%;
  }
}
.button {
  width: 195px;
}
.addEmployeeButton {
  width: 210px;
}

@media screen and (max-width: 1600px) {
  .scroll {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 1110px) {
  .button {
    margin-right: 10px;
    font-size: 12px;
    height: 36px;
    width: 150px;
  }
}

.dropdrop::-webkit-scrollbar {
  display: none;
}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
  z-index: 3;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.black {
  position: relative;
}

.black input {
  border: none;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 600;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

@media screen and (max-width: 763px) {
  .con {
    flex-wrap: wrap;
  }

  .active-inactive-con {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .button {
    height: auto;
  }
}

.is-active {
  background-color: #dedede;
}
.year {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // margin-left: 15px;
  //   margin-top: -7px;
  button {
    width: 36px !important;
    height: 36px;
    display: flex;
    margin-right: 5px;
    border-radius: 6px !important;
    justify-content: center;
    border: #c3d0dd 1px solid;
    background-color: #e9ecef;
    align-items: center;
  }
  h5 {
    border: #b4b4b4 2px solid;
    border-radius: 6px;
    background-color: whitesmoke;
    width: 40%;
    height: 36px;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
  }
}
</style>
